import { useCallback, useEffect, useState } from 'react';
import { useAppInit } from '../contexts/appInitContext';
import { ReasonQuestion } from '../utils/reasonQuestions';
import { useApi } from './useApi';

export interface IreturnReason {
  code: string;
  description: string;
  canUploadPhoto: boolean;
  requiresPhoto: boolean;
  isClaim: boolean;
  reasonQuestionIds: number[];
}
export interface IreturnReasonsResponse {
  reasons: IreturnReason[];
  reasonQuestions: ReasonQuestion[];
}

export interface Ioption {
  value: string | number;
  label: string;
  canUploadPhoto: boolean;
  requiresPhoto: boolean;
  isClaim: boolean;
  // The reason's questions in display order.
  reasonQuestions: ReasonQuestion[];
}

const getOptionsFromReturnReasons = (data: IreturnReasonsResponse): Ioption[] => {
  return data.reasons.map((item) => {
    return {
      value: item.code,
      label: item.description,
      canUploadPhoto: item.canUploadPhoto,
      requiresPhoto: item.requiresPhoto,
      isClaim: item.isClaim,
      reasonQuestions: (item.reasonQuestionIds ?? [])
        .map((id) => {
          return (data.reasonQuestions ?? []).find((question) => {
            return question.id === id;
          });
        })
        .filter((question): question is ReasonQuestion => {
          return question !== undefined;
        }),
    };
  });
};

export const useReturnReasons = (productNo: string) => {
  const api = useApi();

  const {
    params,
  } = useAppInit();

  const [reasons, setReturnReasons] = useState<Ioption[]>([]);
  const [loading, setLoading] = useState(true);

  const getReturnReasons = useCallback(async () => {
    const response = await api(
      `returnreasons?iso6391=${params.languageCode ?? ''}&productNumber=${productNo}&returnType=${params.returnType ?? ''}`,
      'GET',
      '*',
    );
    setLoading(false);
    setReturnReasons(getOptionsFromReturnReasons(response.data));
  }, [api, productNo, params]);

  useEffect(() => {
    getReturnReasons();
  }, [getReturnReasons]);

  return { reasons, loading };
};
